<template>
  <div class="pt-2 border" style="border-radius: 20px">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center w-full mb-2">
        <div>
          <div class="text-dark" style="font-weight: 500; font-size: 18px; line-height: 24px;">Regional Survey</div>
        </div>

        <div>
          <v-select
            style="width: 120px;"
            class="d-inline-block mx-50"
            placeholder="Region"
            :value="graphRegion"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="regionOptions"
            :clearable="true"
            :disabled="loading"
            @input="updateGraphRegion"
          />
          <v-select
            style="width: 120px;"
            class="d-inline-block mx-50"
            placeholder="Year"
            :value="graphYear"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="graphYearOptions"
            :clearable="false"
            :disabled="loading"
            @input="updateGraphYear"
          />
        </div>
      </div>


      <vue-apex-charts
        type="area"
        width="100%"
        height="400"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>

<script>
import { 
  BCol, 
  BRow, 
  BCard, 
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BAvatar,
  BMedia,
  BMediaAside,
  BMediaBody, 
  BFormGroup
} from 'bootstrap-vue'

import VueApexCharts from 'vue-apexcharts'
import vSelect from 'vue-select'
import { get } from "lodash"
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'


export default {
  components: {
    VueApexCharts,
    BCol, 
    BRow,
    BCardHeader, 
    BCardTitle, 
    BCardText,
    BCard,
    BCardBody,
    BAvatar,
    BMedia, 
    BMediaAside, 
    BMediaBody,
    BFormGroup,

    vSelect,
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    series: {
      type: Array,
      default: () => [],
    },
    chartOptions: {
      type: Object,
      default: null,
    },
    graphYear: {
      type: Number,
      required: true
    }
  },
  data() {
    const thisYear = new Date().getFullYear()

    const graphYearOptions = [
      // thisYear
    ];

    for (let yearOption = thisYear - 5; yearOption < thisYear; yearOption += 1){
      graphYearOptions.unshift(yearOption);
    }

    graphYearOptions.unshift(thisYear);

    return {
      graphYearOptions,
      graphRegion: "",
      regionOptions: [],

    }
  },
  created(){
    this.fetchGeoData();
  },
  methods: {
    async fetchGeoData(){
      try {
        this.errorMessage = "";

        const query = {
          geo_id: 2300660
        }
        
        const response = await this.useJwt().mainService.geoData.list(query);
        const data = get(response, 'data.data');

        this.regionOptions = data.map((reg) => reg.name)
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      }
    },
    updateGraphYear(newYear){
      this.$emit('update:graphYear', newYear)
    },
    updateGraphRegion(newRegion){
      this.graphRegion = newRegion;
      this.$emit('graphRegion', newRegion)
    },
  }
}
</script>
